import { render, staticRenderFns } from "./ReactivateMagicLinkButton.vue?vue&type=template&id=d07a2174"
import script from "./ReactivateMagicLinkButton.vue?vue&type=script&lang=ts"
export * from "./ReactivateMagicLinkButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports